/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { Suspense, lazy } from "react"
import { useStaticQuery, graphql } from "gatsby"

import '../css/reflex.css';
import '../css/global.css';

import Header from '../containers/header';
import Footer from '../containers/footer';
import MobileNav from '../components/mobile-nav';
import SearchPopup from '../components/search-popup';

import Logo from '../components/logo';

const TopBanner = lazy(() => import('../components/top-banner'))
const CookieConsentBanner = lazy(() => import('../components/cookie-consent-banner'))
const AttentionPopup = lazy(() => import('../components/attention-popup'))

const isBrowser = typeof window !== "undefined"

const Layout = ({ children, noSignUp }) => {

  const data = useStaticQuery(graphql`
    {
      wp {
        acfOptionsGeneral {
          themeOptionsGeneral {
            showCookieConsentPopup
            showTopBanner
            showPopupOnLoad
          }
        }
      }
    }
  `);

  const { showCookieConsentPopup, showTopBanner, showPopupOnLoad } = data.wp.acfOptionsGeneral.themeOptionsGeneral;

  return (
    <React.Fragment>
      <SearchPopup />
      <MobileNav />
      <div id="outer-container">
        <main id="page-wrap">

          <div className="container navContainer">
            <div className="grid align-center">
                <Logo classNameName="flex-img mobileLogo" />
              <div className="col-5 columnRight">
                <a className="tabletPhone" href="#"><span className="fas fa-phone-volume"></span></a>
              </div>
            </div>
          </div>

          {(isBrowser && showTopBanner) && 
            <Suspense fallback={<p></p>}>
              <TopBanner />
            </Suspense>
          }
          

          <Header />
          {children}
          
          <Footer noSignUp={noSignUp} />
          { (isBrowser && showCookieConsentPopup) &&
            <Suspense fallback={<p></p>}>
              <CookieConsentBanner />
            </Suspense>
          }
          

          { (isBrowser && showPopupOnLoad) &&
            <Suspense fallback={<p></p>}>
              <AttentionPopup />
            </Suspense>
          }
        </main>
      </div>
    </React.Fragment>
  )
}


export default Layout